import { useEffect, useState, RefObject } from 'react';

const useTypographyOverFlowCheck = (
  content: string,
  textRef: RefObject<HTMLElement>,
  containerRef: RefObject<HTMLElement>
) => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);

  useEffect(() => {
    const checkOverflow = () => {
      const el = textRef.current;
      if (el) {
        setIsOverflowing(el.scrollWidth > el.clientWidth);
      }
    };

    checkOverflow();

    const observer = new ResizeObserver(() => {
      checkOverflow();
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [content, textRef, containerRef]);

  return { isOverflowing };
};

export default useTypographyOverFlowCheck;
